export const getXRFHeaderValue = () => {
  const tokenElement = document.getElementsByName("__RequestVerificationToken");

  if (!tokenElement || tokenElement.length <= 0) {
    throw "RequestVerificationToken cannot be found";
  }

  const headerValue = tokenElement[0].value;
  if (!headerValue) {
    throw "RequestVerificationToken cannot be found";
  }

  console.log("tokenElement:" + headerValue);
  return headerValue;
};


// WEBPACK FOOTER //
// ./src/utils/getXRFHeaderValue.js